export function getCellClass(cell) {
  if (!cell.column.cellClass) {
    return '';
  }
  return typeof cell.column.cellClass === 'function' ? cell.column.cellClass(cell) : cell.column.cellClass;
}

export function getSubCellClass(cell) {
  if (!cell.column.subCellClass) {
    return '';
  }
  return typeof cell.column.subCellClass === 'function' ? cell.column.subCellClass(cell) : cell.column.subCellClass;
}
